const contactProtocolFieldMap = {
  email: 'email',
  sms: 'phone',
  twitter_dm: 'twitterUsername',
  whats_app: 'phone',
  apns: 'hasApplePushPermission',
};

export default contactProtocolFieldMap;
